export const SOCKET_USERS_RECEIVE = "SOCKET_USERS_RECEIVE";
export const SOCKET_ALL_ONLINE_USERS_LIST = "SOCKET_ALL_ONLINE_USERS_LIST";
export const REST_ALL_SOCKET_DATA = "REST_ALL_SOCKET_DATA";

